import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_EQUIPMENT_SUB_TYPE_SUCCESS,
  FETCH_EQUIPMENT_SUB_TYPE_SUCCESS,
  GET_EQUIPMENT_SUB_TYPE_SUCCESS,
  REFRESH_EQUIPMENT_SUB_TYPE_DATA,
  SAVE_EQUIPMENT_SUB_TYPE_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_EQUIPMENT_SUB_TYPE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_EQUIPMENT_SUB_TYPE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_EQUIPMENT_SUB_TYPE_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_EQUIPMENT_SUB_TYPE_SUCCESS,
    data
  };
};

export const refreshData = () => {
  return {
    type: REFRESH_EQUIPMENT_SUB_TYPE_DATA,
  }
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {equipmentSubType} = store.getState();
      const {query} = equipmentSubType;
      const response = await axios.get(`/equipment-sub-type?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {equipmentSubType} = store.getState();
      const {query} = equipmentSubType;
      const response = await axios.get(`/equipment-sub-type/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      let formData = new FormData();
      const documentData = [];
      payload.documents && payload.documents.length && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data)
      });
      if(payload.IconFile && payload.IconFile.file) {
        formData.append('fileIcon', payload.IconFile.file);
      }
      formData.append('documentData', JSON.stringify(documentData));
      if(!payload.checklist) {
        payload.checklist = [];
      }
      if(!payload.service) {
        payload.service = [];
      }

      Object.keys(payload).forEach(key => {
        if(key === 'documents' && key === 'files[]') {
          return
        }
        if(key === 'checklist' || key === 'service') {
          formData.append(key, JSON.stringify(payload[key]));
          return
        }

        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/equipment-sub-type`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if(superMaster) {
            dispatch(fetchSuperMasterFilter(module))
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/equipment-sub-type');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      if(payload.files && payload.files.file) {
        formData.append('fileIcon', payload.files.file);
      }
      payload.documents && payload.documents.length && payload.documents.map((item, index) => {
        if(!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return
        }
        if(key === 'checklist' || key === 'service') {
          formData.append(key, JSON.stringify(payload[key]));
          return
        }

        formData.append(key, payload[key]);
      });

      const response = await axios.put(`/equipment-sub-type/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }

      dispatch(fetchSuccess());
      history.push('/equipment-sub-type');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/equipment-sub-type/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/common/sub-type/${id}`);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
